import Cookie from 'js-cookie';

import { cookieMetric } from './../modules/metrics';
import { logError } from './errorTracking';

/**
 * It has been observed that if cookies are removed after a http 431 error, that the same
 * call is then likely to succeed. This bigCookies array is not exhaustive, and there may
 * be other cookies that should be removed. This list was put together by logging the cookie
 * and its length in Datadog (in this method), and sorting by length.
 */

const attemptToCookieMap: Record<number, string[]> = {
  1: [
    's_cpmcvp',
    'main',
    'amcv_199e4673527852240a490d45_adobeorg',
    's_sq',
    'amplitude_id_16e3dbc2760348e9cf2e66ecf7d5241eseek.com.au',
    'amplitude_id_97ab968920f4e1f358b3910bb5d62f77seek.com.au',
    'cto_bundle',
  ],
  /**
   * these cookies are important for the analytics/marketing teams - so we only delete
   * these if they are blockers for a user trying to log-in - else we don't remove these
   */
  2: [
    // tealium cookie
    'utag_main',
    // amplitude (analytics) cookie
    'da_marketing_channel_value',
    'qsi_historysession',
  ],
};

const cookieWhiteList: string[] = ['auth0-mf', 'auth0-mf_compat'];

export const deployCookieMonster = (attempt: number): string[] => {
  try {
    const allCookies: string[] = Object.keys(Cookie.get()) as string[];

    const allCookiesRemoved = allCookies.reduce<string[]>(
      (cookiesRemoved, cookieName) => {
        if (attempt === 3 || attemptToCookieMap[attempt].includes(cookieName)) {
          if (!cookieWhiteList.includes(cookieName)) {
            Cookie.remove(cookieName);
            cookiesRemoved.push(cookieName);
          }
        }
        return cookiesRemoved;
      },
      [],
    );

    cookieMetric([
      `cookies_removed:${allCookiesRemoved?.length}`,
      `cookies_spared:${allCookies.length - allCookiesRemoved.length}`,
    ]);

    return allCookiesRemoved;
  } catch (err) {
    logError('Error in cookie monster', err);
    return [];
  }
};
